export * from "./SmallCard";
